import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { CaretDown } from "components/icons/CaretDown";

export type AddEntityMode = "parent" | "subsidiary" | "separate";

type AddAnotherEntityDropdownProps = {
  onAdd: (mode: AddEntityMode) => void;
};

export const AddAnotherEntityDropdown = ({
  onAdd,
}: AddAnotherEntityDropdownProps) => {
  return (
    <div className="t-flex t-items-center t-gap-2">
      <span className="t-text-body-sm t-text-text-30">
        Manage multiple entities?
      </span>
      <Dropdown.Root>
        <Dropdown.Trigger asChild>
          <Button customType="link" size="small" rightIcon={<CaretDown />}>
            Add another entity
          </Button>
        </Dropdown.Trigger>
        <Dropdown.Portal>
          <Dropdown.Content align="start" sideOffset={4}>
            <Dropdown.Item onSelect={() => onAdd("parent")}>
              Add parent
            </Dropdown.Item>
            <Dropdown.Item onSelect={() => onAdd("subsidiary")}>
              Add subsidiary
            </Dropdown.Item>
            <Dropdown.Item onSelect={() => onAdd("separate")}>
              Add separate entity
            </Dropdown.Item>
          </Dropdown.Content>
        </Dropdown.Portal>
      </Dropdown.Root>
    </div>
  );
};
